import { TabPoint } from 'components/user/user-detail/tab-point/TabPoint'
import { INITIAL_DATA_FILTER } from 'configs/user/user-detail/configTablePoint'
import { useEffect } from 'react'
import { useLocation, useSearchParams } from 'react-router-dom'
import { API_USER } from 'services/apiUser'
import { useFetch } from 'services/useFetch'
import { getAllQueryParams, setQueryParams } from 'utils/utils'

export const TabPointContainer = ({ id }) => {
    const location = useLocation()
    const [searchParams, setSearchParams] = useSearchParams()
    const query = getAllQueryParams(searchParams)
    const {
        data: pointHistory,
        fetching: getWaitListApi,
        isLoading,
    } = useFetch({ ...API_USER.POINT_HISTORY, initPathVariable: id }, INITIAL_DATA_FILTER)

    useEffect(() => {
        const { tabName, userId, ...queryParams } = query
        getWaitListApi({ ...queryParams })
    }, [location?.search])

    const onChangeQuery = (queryParams) => {
        const params = setQueryParams({ ...query, ...queryParams })
        setSearchParams(params, { replace: true })
    }

    const props = {
        dataList: pointHistory?.data,
        query,
        onChangeQuery,
        isLoading,
    }

    return <TabPoint {...props} />
}
